/* globals Stripe */
import Request, { showLoader, hideLoader } from './request';

class StripeService {
  constructor() {
    this.instance = null;
  }

  init(config) {
    if (typeof Stripe !== 'undefined') {
      if (config && config.key) {
        this.instance = Stripe(config.key);
      }
    }
  }

  updateStripeKey(config) {
    if (typeof Stripe !== 'undefined') {
      if (config && config.key) {
        this.instance = Stripe(config.key);
      }
    }
  }

  handleError(err) {
    console.log('*** handleError:().err.type: ', err ? err.type : '-');
    if (!err) {
      return null;
    }

    switch (err.type) {
      case 'card_error':
        console.log('*** handleError:().err.code: ', err.code);
        switch (err.code) {
          case 'invalid_expiry_year':
            return 'ERROR_CREDIT_CARD_EXPIRED';
          case 'incorrect_cvc':
            return 'ERROR_CARD_CVC_INCORRECT';
          case 'expired_card':
            return 'ERROR_CREDIT_CARD_EXPIRED';
          case 'processing_error':
            return 'ERROR_CARD_PROCESSING';
          case 'missing':
            return 'ERROR_MISSING_PAYMENT_CARD';
          case 'card_declined':
            console.log(
              '*** handleError:().err.decline_code: ',
              err.decline_code,
            );
            if (err.decline_code) {
              if (err.decline_code === 'insufficient_funds') {
                return 'ERROR_PAYMENT_DENIED_NO_FUNDS';
              }
            }
            return 'ERROR_PAYMENT_DENIED';
          default:
            return 'ERROR_PAYMENT_DENIED';
        }
      default:
        switch (err.message) {
          case 'Invalid positive integer':
            return 'ERROR_INVALID_PRICE';
          case 'You cannot use a live bank account number when making transfers or debits in test mode':
            return 'ERROR_INVALID_IBAN_TEST';
          case "We couldn't find the bank for this account number":
            return 'ERROR_INVALID_IBAN';
          case 'Date of birth must be in the past':
            return 'ERROR_INVALID_BIRTHDAY';
          default:
            if (err.message.indexOf('Invalid integer:') !== -1) {
              return 'ERROR_INVALID_PRICE';
            }
            if (err.message.indexOf('Invalid currency:') !== -1) {
              return 'ERROR_INVALID_CURRENCY';
            }
            if (err.message.indexOf(' postal code') !== -1) {
              return 'ERROR_INVALID_POST_CODE_COUNTRY';
            }
            return err.message;
        }
    }
  }

  async createToken(element) {
    if (!this.instance) {
      throw 'ERROR_STRIPE_NOT_INITIALIZED';
    }

    const { error, token } = await this.instance.createToken(element);
    if (error) {
      throw this.handleError(error);
    }
    return {
      ...(token.card || {}),
      token: token.id,
    };
  }

  elements() {
    if (!this.instance) {
      throw 'ERROR_STRIPE_NOT_INITIALIZED';
    }

    return this.instance.elements();
  }

  handlePaymentConfirmation(paymentMethod, secret) {
    console.log(
      `*** StripeService.handlePaymentConfirmation:(${paymentMethod}).secret: `,
      secret,
    );
    return new Promise((resolve, reject) => {
      this.instance
        .confirmCardPayment(secret, { payment_method: paymentMethod })
        .then(confirmResult => {
          console.log(
            `*** StripeService.handlePaymentConfirmation:(${paymentMethod}).confirmResult: `,
            confirmResult,
          );
          if (confirmResult.error) {
            reject(this.handleError(confirmResult.error));
          } else if (confirmResult.paymentIntent.status === 'succeeded') {
            resolve(confirmResult.paymentIntent);
          } else {
            this.instance.handleCardPayment(secret).then(result => {
              if (result.error) {
                reject(result.error);
              } else {
                resolve(result.paymentIntent);
              }
            });
          }
        });
    });
  }

  initiatePayment(_csrf, params) {
    return new Promise((resolve, reject) => {
      showLoader();
      if (!this.instance) {
        hideLoader();
        reject('ERROR_STRIPE_NOT_INITIALIZED');
      } else {
        const handleError = err => {
          hideLoader();
          reject(this.handleError(err));
        };

        const handleSuccess = data => {
          hideLoader();
          resolve(data);
        };

        const handleFinalize = clientSecret => {
          this.instance.handleCardPayment(clientSecret).then(result => {
            if (result.error) {
              handleError(result.error);
            } else {
              handleSuccess(result.paymentIntent);
            }
          });
        };

        const handleConfirmation = clientSecret => {
          const payment_method = params.paymentMethod;
          showLoader();
          this.instance
            .confirmPaymentIntent(clientSecret, { payment_method })
            .then(confirmResult => {
              if (confirmResult.error) {
                handleError(confirmResult.error);
              } else if (confirmResult.paymentIntent.status === 'succeeded') {
                handleSuccess(confirmResult.paymentIntent);
              } else {
                handleFinalize(clientSecret);
              }
            });
        };

        const url = params.orderId ? '/payment/shop' : '/payment';
        new Request(_csrf)
          .post(url, params)
          .done(({ data }) => {
            if (data.error) {
              handleError(data.error);
            } else {
              handleConfirmation(data.payment_intent_client_secret);
            }
          })
          .fail(responseError => {
            hideLoader();
            const err = responseError.responseJSON;
            reject(err.message || err.error);
          });
      }
    });
  }
}

const instance = new StripeService();
export default instance;
